<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading>
<div *ngIf="router.url =='/main/job-data'" class="max-w-8xl">
  <form [formGroup]="addForm">
    <div (click)="showWindow = !showWindow" *ngIf="showWindow"
         class="w-full h-screen bg-black top-0 left-0 z-20 bg-opacity-40 fixed flex items-center justify-center"></div>
    <div *ngIf="showWindow"
         class="bg-white rounded-lg shadow-xl p-8 fixed z-30 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full max-w-md">
      <div class="text-3xl font-semibold text-gray-800 mb-6 text-center"> {{ 'Добавление' | translate }}</div>
      <div class="mb-4">
        <div>
          <label class="block text-gray-700 text-sm font-bold mb-2"> {{ 'БИН' | translate }} </label>
          <input maxlength="12" formControlName="bin" type="text"
                 class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline transition duration-200 ease-in-out"
                 [ngClass]="{'border-red-500': addForm.get('bin')?.invalid && (addForm.get('bin')?.touched)}"
                 placeholder="000000000000">
          <div *ngIf="addForm.get('bin')?.invalid && (addForm.get('bin')?.touched)"
               class="text-red-500 text-xs italic mt-2">
            {{ 'Поле обязательно для заполнения' | translate }}
          </div>
        </div>
      </div>
      <div class="flex justify-between space-x-4 mt-6">
        <button (click)="setJob()"
                class="flex-1 bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-lg focus:outline-none focus:shadow-outline transition duration-200 ease-in-out">
          {{ 'Добавить' | translate }}
        </button>
        <button (click)="closeWindow()"
                class="flex-1 bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded-lg focus:outline-none focus:shadow-outline transition duration-200 ease-in-out">
          {{ 'Отмена' | translate }}
        </button>
      </div>
    </div>
  </form>

  <div class="justify-center">
    <div class="w-full">
      <div class="bg-white rounded-lg shadow-lg p-1 mb-2">
        <div class="text-xl font-bold text-gray-900 mb-3 text-center">Места работ</div>
        <form [formGroup]="form" class="md:grid-cols-2 lg:grid-cols-3 gap-4 mb-3">
          <fieldset>
              <div class="flex">
                <label class="text-gray-700 mt-2 text-sm font-bold mr-2"> БИН </label>
                <div class="flex shadow border rounded-l-lg bg-gray-100 rounded">
                  <input
                    class="mr-2 w-4 ml-2"
                    [value]="1"
                    type="radio"
                    [(ngModel)]="searchChecker"
                    [ngModelOptions]="{standalone: true}"
                    >
                  <input
                    style="width: 15rem"
                    maxlength="12"
                    formControlName="bin"
                    placeholder="000000000000"
                    class="appearance-none rounded-r py-2 px-3 text-gray-700 leading-tight focus:outline-none transition
                    focus:shadow-outline duration-200 ease-in-out"
                    oninput="this.value = this.value.replace(/[^0-9]/g, '');">
                </div>
                <button
                  *ngIf="searchChecker == 1"
                  (click)="getJobByBin()"
                  class="bg-blue-500 hover:bg-blue-600 ml-3 text-white py-1 px-4 rounded-lg shadow-md
                  focus:outline-none focus:shadow-outline duration-200 ease-in-out disabled:opacity-50
                  disabled:cursor-not-allowed"
                  [disabled]="!this.form.get('bin')?.value || form.get('bin')?.value?.length !== 12">
                  Поиск
                </button>
              </div>
            <div class="border-2 mt-10 rounded p-3 border-gray-100 relative">
              <div class="flex">
                <div class="radio-container flex">
                  <input
                    class="radio-button rounded"
                    [value]="2"
                    type="radio"
                    [(ngModel)]="searchChecker"
                    [ngModelOptions]="{standalone: true}"
                   >
                  <p class="ml-1">
                    Поиск по параметрам
                  </p>
                </div>
                <label class="mt-4 w-28 text-gray-700 text-sm font-bold"> {{ 'Область' | translate }} </label>
                <select
                  [disabled]="searchChecker != 2"
                  (change)="findAllParam(true)"
                  [(ngModel)]="oblId"
                  [ngModelOptions]="{standalone: true}"
                  class="shadow appearance-none border rounded w-full mt-2 py-2 px-3 text-gray-700 leading-tight
                  focus:outline-none focus:shadow-outline transition duration-200 ease-in-out ml-3">
                  <option [value]="null" disabled selected> {{ 'Область' | translate }}</option>
                  <option
                    [disabled]="!this.form.get('searchByName')?.value"
                    [value]="0"
                    (change)="findAllParam()">
                    Все области
                  </option>
                  <option *ngFor="let item of oblList" [value]="item.id">
                    <span *ngIf="translate.currentLang == 'kz'"> {{ item.nameKaz }} </span>
                    <span *ngIf="translate.currentLang == 'ru'"> {{ item.nameRus }} </span>
                  </option>
                </select>
              </div>
              <div class="mt-3">
                <div class="flex">
                  <label class="mt-2 w-28 text-gray-700 text-sm font-bold mb-2"> Наименование </label>
                    <input
                      (keyup)="onKeyup($event)"
                      formControlName="searchByName"
                      placeholder="Наименование"
                      class="rounded w-full ml-3 border py-2 px-3 text-gray-700 shadow">
                </div>
              </div>
            </div>
          </fieldset>
        </form>
        <div class="flex flex-wrap gap-4 justify-center md:justify-end">
          <button (click)="openWindow()"
                  class="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-6 rounded-lg shadow-md focus:outline-none focus:shadow-outline transition duration-200 ease-in-out">
            Добавить
          </button>
        </div>
      </div>

<!--000240002082-->
                                                        <!--                 -->
                                                        <!--  Таблица Бин    -->
                                                        <!--                 -->
      <div *ngIf="binJobList != null && searchChecker == 1" class="bg-white rounded-lg shadow-lg p-1 flex flex-col lg:flex-row gap-6">
        <div class="flex-1">
          <div class="max-h-[500px] max-w-[1300px] border border-gray-200 rounded-lg">
            <table class="text-left table-auto">
              <thead class="bg-gray-50 sticky top-0">
              <tr>
                <th
                  class="px-6 py-3 border-b-2 border-gray-200 text-gray-800 text-sm leading-4 font-semibold tracking-wider">
                  БИН
                </th>
                <th
                  class="px-6 py-3 border-b-2 border-gray-200 text-gray-800 text-sm leading-4 font-semibold tracking-wider">
                  Наименование
                </th>
              </tr>
              </thead>
              <tbody>
              <tr class="hover:bg-gray-50 transition duration-150 ease-in-out">
                <td class="px-6 py-4 border-b border-gray-200">
                  <span class="text-gray-900">{{ binJobList.bin }}</span>
                </td>
                <td class="px-6 py-4 w-full border-b border-gray-200">
                  <span *ngIf="translate.currentLang == 'kz'" class="text-gray-900"> {{ binJobList.nameKaz }} </span>
                  <span *ngIf="translate.currentLang == 'ru'" class="text-gray-900"> {{ binJobList.nameRus }} </span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="lg:w-1/4 bg-gray-50 p-6 rounded-lg shadow-inner border border-gray-200">
          <p class="mb-2"><b class="font-medium text-gray-700">БИН:</b> <span
            class="text-gray-900"> {{ binJobList.bin }} </span></p>
          <p class="mb-2"><b class="font-medium text-gray-700">Наименование на казахском:</b>
            <span class="text-gray-900"> {{ nameKaz }} </span>
          </p>
          <p class="mb-2"><b class="font-medium text-gray-700">Наименование на русском:</b>
            <span class="text-gray-900"> {{ nameRus }} </span>
          </p>
          <p class="mb-2"><b class="font-medium text-gray-700">Область:</b>
            <span *ngIf="translate.currentLang == 'kz'" class="text-gray-900"> {{ binJobList.oblNameKaz }} </span>
            <span *ngIf="translate.currentLang == 'ru'" class="text-gray-900"> {{ binJobList.oblNameRus }} </span>
          </p>
          <p class="mb-4"><b class="font-medium text-gray-700">Район:</b>
            <span *ngIf="translate.currentLang == 'kz'" class="text-gray-900"> {{ binJobList.raionNameKaz }} </span>
            <span *ngIf="translate.currentLang == 'ru'" class="text-gray-900"> {{ binJobList.raionNameRus }} </span>
          </p>
          <button
            (click)="updateJob(id)"
            class="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded-lg shadow
            focus:outline-none focus:shadow-outline transition duration-200 ease-in-out">
            Обновить данными из ГБДЮЛ
          </button>
        </div>
      </div>
                                                  <!--                     -->
                                                  <!--  Таблица области    -->
                                                  <!--                     -->
      <div *ngIf="searchChecker == 2 && (oblId != null || this.form.get('searchByName')?.value)" class="bg-white rounded-lg shadow-lg p-2 flex flex-col lg:flex-row gap-6">
        <div class="flex-1">
          <div class="max-h-[500px] max-w-[1300px] border border-gray-200 rounded-lg">
            <table class="text-left table-auto">
              <thead class="bg-gray-50 sticky top-0">
              <tr>
                <th
                  class="px-6 py-3 border-b-2 border-gray-200 text-gray-800 text-sm leading-4 font-semibold tracking-wider">
                  БИН
                </th>
                <th
                  class="px-6 py-3 border-b-2 border-gray-200 text-gray-800 text-sm leading-4 font-semibold tracking-wider">
                  Наименование
                </th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let job of allList; index as i"
                  [ngClass]="{'bg-blue-50': hoverOnJob == job.id}"
                  (click)="oknoData(job)"
                  class="hover:bg-gray-50 transition duration-150 ease-in-out cursor-pointer">
                <td class="px-6 py-4 border-b border-gray-200">
                  <span class="text-gray-900">{{ job.bin }}</span>
                </td>
                <td class="border-b w-full border-gray-200">
                  <span *ngIf="translate.currentLang == 'kz'" class="text-gray-900"> {{ job.nameKaz }} </span>
                  <span *ngIf="translate.currentLang == 'ru'" class="text-gray-900"> {{ job.nameRus }} </span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="flex justify-between items-center mt-4">
            <div class="flex items-center space-x-2">
            </div>
            <div class="flex space-x-2">
              <button [disabled]="pageNumber === 0" (click)="changePage(pageNumber - 1)"
                      class="px-4 py-2 bg-gray-200 rounded-lg text-gray-700 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed transition duration-200 ease-in-out">
                Предыдущая
              </button>
              <input id="pageInput" type="text" min="1" [max]="totalPages"
                     [(ngModel)]="goToPageNumber"
                     (keyup.enter)="goToPage()"
                     class="w-10 h-10 text-center p-1 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"/>
              <span class="px-4 py-2 text-gray-700">Страница {{ pageNumber + 1 }} из {{ totalPages }}</span>
              <button [disabled]="pageNumber === totalPages - 1" (click)="changePage(pageNumber + 1)"
                      class="px-4 py-2 bg-gray-200 rounded-lg text-gray-700 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed transition duration-200 ease-in-out">
                Следующая
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="informWindow == true"
             class="lg:w-1/4 bg-gray-50 p-6 rounded-lg shadow-inner border border-gray-200">
          <div *ngIf="hoverOnJob">
            <p class="mb-2"><b class="font-medium text-gray-700">БИН:</b>
              <span class="text-gray-900"> {{ bin }} </span>
            </p>
            <p class="mb-2"><b class="font-medium text-gray-700">Наименование на казахском:</b>
              <span class="text-gray-900"> {{ nameKaz }} </span>
            </p>
            <p class="mb-2"><b class="font-medium text-gray-700">Наименование на русском:</b>
              <span class="text-gray-900"> {{ nameRus }} </span>
            </p>
            <p class="mb-2"><b class="font-medium text-gray-700">Область:</b>
              <span *ngIf="translate.currentLang == 'kz'" class="text-gray-900"> {{ oblNameKaz }} </span>
              <span *ngIf="translate.currentLang == 'ru'" class="text-gray-900"> {{ oblNameRus }} </span>
            </p>
            <p class="mb-4"><b class="font-medium text-gray-700">Район:</b>
              <span *ngIf="translate.currentLang == 'kz'" class="text-gray-900"> {{ raionNameKaz }} </span>
              <span *ngIf="translate.currentLang == 'ru'" class="text-gray-900"> {{ raionNameRus }} </span>
            </p>
            <button (click)="updateJob(id)"
                    class="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded-lg shadow
               focus:outline-none focus:shadow-outline transition duration-200 ease-in-out">
              Обновить данными из ГБДЮЛ
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<router-outlet></router-outlet>
